import i18n from '@/i18n';
import Storage from '@/modules/storage';
import CountryCodes from '@/lib/CountryCodes';
import SupportedCountryCodes from '@/lib/SupportedCountryCodes';

const DEFAULT_COUNTRY_CODE_MAP = {
  'zh-tw': 'zh-TW',
  zh: 'zh-TW',
  'zh-cn': 'zh-CN',
  cn: 'zh-CN',
  'en-us': 'US',
  en: 'US',
  fr: 'FR',
  ja: 'JP',
  de: 'DE',
  es: 'ES',
  it: 'IT',
  ko: 'KR',
};

const getCountryCode = () =>
  Storage.getCountryCode() || SupportedCountryCodes.find(c => c.code === DEFAULT_COUNTRY_CODE_MAP[i18n.locale]) || SupportedCountryCodes[0];

const handlePhoneInput = {
  data: () => ({
    showCountryCode: false,
    localNumber: '',
    countryCode: getCountryCode(),
  }),
  methods: {
    openCountryCode() {
      this.showCountryCode = true;
    },
    closeCountryCode() {
      this.showCountryCode = false;
    },
    setLocalPhone(phone) {
      if (!phone) {
        this.countryCode = getCountryCode();
        return;
      }

      for (const c of CountryCodes) { // eslint-disable-line
        if (phone.indexOf(c.value) === 0) {
          this.countryCode = c;
          this.localNumber = phone.replace(c.value, '');
          break;
        }
      }
    },
  },
  computed: {
    phoneNumber() {
      let phoneNumber = this.localNumber;
      if (phoneNumber.indexOf('0') === 0) {
        phoneNumber = phoneNumber.substring(1);
      }
      return `${this.countryCode.value}${phoneNumber}`;
    },
  },
};

export default handlePhoneInput;
